import React, { FC } from 'react';

import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import { AbstractIcon } from '../abstract-icon';

interface Props {
  className?: string;
}

const HideIcon: FC<Props> = props => <AbstractIcon {...props} icon={faEyeSlash} />;

export { HideIcon };